import React from 'react';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as fileApi from '../../../lib/api/file';
import * as employeeApi from '../../../lib/api/employee';
import { setEmployee } from '../../../modules/empModule/employee';
import EmpFileUpload from '../../../components/common/fileupload/EmpFileUpload';

const EmpFileUploadContainer = ({fileTyp, fileAttrVal1}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const uploadProfileImage = async (file) => {
    let formData = new FormData();
    formData.append('fileDt', file);
    formData.append('fileTyp', fileTyp);
    formData.append('fileAttrVal1', fileAttrVal1);

    try {
      const res = await fileApi.addFiles(formData);
      
      
      const dataToSubmit = {
        usrUuid: fileAttrVal1,
        profileImg: res.data.info.fileUrl,
      };
      const usrRes = await employeeApi.editEmployee(dataToSubmit);
      console.log(usrRes);
      dispatch(setEmployee(usrRes.data.info));
      enqueueSnackbar('사용자 프로필 이미지 저장 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return <EmpFileUpload uploadProfileImage={uploadProfileImage} />;
};

export default EmpFileUploadContainer;
